import { Button, Col, Form, Row, Select, Table } from "antd";
import React, { useState } from "react";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import FilterContainer from "../../../components/common/FilterContainer";
import MultiSelect from "../../../components/common/MultiSelect";
import { reportsList, receiptList, reportstable } from './scheduledReportsData'
import { useNavigate } from 'react-router-dom';


const ScheduledReportsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("New Scheduled Report", "1", "", "", "/reporting/scheduled-reports/new"),

  ]),
];
function ScheduledReports() {
  const [sortedInfo, setSortedInfo] = useState({});
  const navigate = useNavigate();
  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setSortedInfo(sorter);
  };
  const tableHeader = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
      render: (text) => <span className="onclick-text">{text}</span>,
      width: 200,
    },
    {
      title: "Reports",
      dataIndex: "reports",
      key: "reports",
      sorter: (a, b) => a.reports.length - b.reports.length,
      sortOrder: sortedInfo.columnKey === "reports" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      sorter: (a, b) => a.frequency.length - b.frequency.length,
      sortOrder: sortedInfo.columnKey === "frequency" ? sortedInfo.order : null,
      ellipsis: true,
      width: 200,

    },
    {
      title: "Last Sent On",
      dataIndex: "lastSentOn",
      key: "lastSentOn",
      sorter: (a, b) => a.lastSentOn.length - b.lastSentOn.length,
      sortOrder: sortedInfo.columnKey === "lastSentOn" ? sortedInfo.order : null,
      ellipsis: true,
      width: 200,

    },
  ];



  return (
    <>
      <div>
        <PageHeading heading="Scheduled Reports" />
        <Row>
          <Col span={24}>
            <FilterContainer heading="Filter scheduled reports with the options below:">
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Reports">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Recipient">
                      <Select
                        showSearch
                        allowClear
                        placeholder="Search by recipient"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                        options={[]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Frequency">
                      <Select
                        showSearch
                        placeholder="Search by frequency"
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        style={{
                          width: "100%",
                        }}
                        options={[
                          {
                            value: 'Daily',
                            label: 'Daily',
                          },
                          {
                            value: 'Weekly',
                            label: 'Weekly',
                          },
                          {
                            value: 'Monthly',
                            label: 'Monthly',
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>

                </Row>
                <Form.Item label=" ">
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <br />
        <Table
          columns={tableHeader}
          dataSource={[]}
          rowKey="key"
          onChange={handleChange}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                console.log("Clicked Row data :", record);
                navigate('/reporting/scheduled-reports/scheduled-reports-details',
                  { state: { rowData: record } });
              },
            };
          }}

        />
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ScheduledReportsRightBar} />
      </div>
    </>
  );
}

export default ScheduledReports;